import React from "react";
import { Card, Button } from "react-bootstrap";
import defaultConfig from "./config";

const Preview = ({ previewDevice, setPreviewDevice, branding, editingSurvey, questions, renderQuestionPreview, getBackgroundStyle }) => {
  const companyLogo = localStorage.getItem("companylogo");
  const logoNetShine = companyLogo && companyLogo.trim() 
    ? `${defaultConfig.cdnUrl}/${companyLogo}` 
    : 'https://netshine-assets.blr1.digitaloceanspaces.com/company_87/logos/company_logo_87_1739613280498';
  const defaultLogoSrc = companyLogo && companyLogo.trim() 
    ? `${defaultConfig.cdnUrl}/${companyLogo}` 
    : logoNetShine;

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="mb-0 fw-bold">Configuration Preview</h4>
        <div>
          <Button
            variant={previewDevice === "desktop" ? "primary" : "outline-primary"}
            onClick={() => setPreviewDevice("desktop")}
            className="me-2 px-2 py-1"
            aria-label="Desktop Preview"
          >
            Desktop
          </Button>
          <Button
            variant={previewDevice === "mobile" ? "primary" : "outline-primary"}
            onClick={() => setPreviewDevice("mobile")}
            className="px-2 py-1"
            aria-label="Mobile Preview"
          >
            Mobile
          </Button>
        </div>
      </Card.Header>
      <Card.Body style={{ padding: "0" }}>
        <div
          style={{
            width: previewDevice === "mobile" ? "375px" : "100%",
            height: previewDevice === "mobile" ? "667px" : "auto",
            margin: previewDevice === "mobile" ? "0 auto" : "0",
            border: previewDevice === "mobile" ? "10px solid #333" : "none",
            borderRadius: previewDevice === "mobile" ? "30px" : "0",
            overflow: "hidden",
            boxShadow: previewDevice === "mobile" ? "0 4px 12px rgba(0, 0, 0, 0.3)" : "none",
            background: getBackgroundStyle(),
            position: "relative",
          }}
        >
          <div style={{ padding: "20px", height: "100%", overflowY: "auto" }}>
            {branding.showLogo && (
              <img
                src={branding.logoSrc || defaultLogoSrc}
                alt="Logo"
                style={{ 
                  width: `${branding.logoWidth || 150}px`, 
                  height: `${branding.logoHeight || 'auto'}px`, 
                  display: "block", 
                  margin: "0 auto 20px", 
                  borderRadius: "8px" 
                }}
                aria-label="Logo Preview"
              />
            )}
            <h4
              style={{
                textAlign: "center",
                color: branding.titleColor,
                marginBottom: "20px",
                fontWeight: "600",
                fontSize: `${branding.titleFontSize}rem`,
              }}
            >
              {editingSurvey?.title || "Sample Survey"}
            </h4>
            {questions.map((q) => (
              <div key={q.id} className="question-block mb-4">
                <div className="question-label" style={{ fontSize: "16px", fontWeight: "500", color: "#333", marginBottom: "10px" }}>
                  {q.label} {q.required && <span style={{ color: "#dc3545" }}>*</span>}
                </div>
                {renderQuestionPreview(q)}
              </div>
            ))}
            <Button
              style={{
                backgroundColor: branding.themeColor,
                borderRadius: branding.buttonStyle === "rounded" ? "20px" : "0",
                width: "100%",
                padding: "10px",
                fontSize: "16px",
                fontWeight: "500",
                border: "none",
                color: "#fff",
                textTransform: "uppercase",
              }}
              aria-label="Submit Preview"
            >
              Submit
            </Button>
            {editingSurvey?.thankYouMessage && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  color: "#333",
                  fontSize: "16px",
                }}
              >
                {editingSurvey.thankYouMessage}
              </div>
            )}
            {editingSurvey?.redirectUrl && editingSurvey?.redirectMessage && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  color: "#007bff",
                  fontSize: "14px",
                }}
              >
                <a href={editingSurvey.redirectUrl} target="_blank" rel="noopener noreferrer">
                  {editingSurvey.redirectMessage}
                </a>
              </div>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default Preview;